module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.href,
      "active-class": "active",
      "tag": "a",
      "exact": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ca4c5e72", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca4c5e72","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VLink.vue
// module id = 61
// module chunks = 0 1